"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Line = exports.TitleWrapper = exports.HeaderWrapper = exports.RoundImg = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const fadein = (0, styled_components_1.keyframes) `
  from { opacity: 0; }
  to   { opacity: 1; }
`;
exports.RoundImg = styled_components_1.default.img `
  border: 1px solid #e1e4e8;
  border-radius: 100%;
  animation: ${fadein} 1s ease;
`;
exports.HeaderWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-around;
  align-self: stretch;
  align-items: center;

  @media (max-width: 640px) {
    flex-direction: column;
    & > ${exports.RoundImg} {
      margin-top: 40px;
    }
  }
`;
exports.TitleWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: stretch;
  /* title */
  h5 {
    font-weight: normal;
    font-size: 24px;
    line-height: 34px;

    margin: 10px 5px;
  }
  /* subtitle */
  p {
    font-size: 16px;
    margin: 5px;
  }
`;
exports.Line = styled_components_1.default.div `
  flex: 1 1;
  height: 2px;
  background: #ebebeb;
`;
